/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Aria_NavigationInputs */

const en_footer_aria_navigation = /** @type {(inputs: Footer_Aria_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Footer navigation`)
};

const es_footer_aria_navigation = /** @type {(inputs: Footer_Aria_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegación del pie de página`)
};

/**
* | output |
* | --- |
* | "Footer navigation" |
*
* @param {Footer_Aria_NavigationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const footer_aria_navigation = /** @type {((inputs?: Footer_Aria_NavigationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Aria_NavigationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_aria_navigation(inputs)
	return en_footer_aria_navigation(inputs)
});